import styled, { css, SimpleInterpolation } from 'styled-components';
import { up } from 'styled-breakpoints';

export const ContentWrapper = styled.main`
  height: 100%;
  display: flex;
`;

interface ContentProps {
  bottomPadding: string;
}

export const Content = styled.div<ContentProps>`
  height: 100%;
  width: 100%;

  ${up('tablet-landscape')} {
    flex: 1 1 auto;
    min-width: 0;
    min-height: 0;
  }

  & > div {
    padding-bottom: ${({ bottomPadding }): string => bottomPadding};
  }
`;

interface LayoutProps {
  hasAppBarScrollTransition?: boolean;
  isScrolled?: boolean;
  topPadding?: string;
}

export const Layout = styled.div<LayoutProps>`
  height: 100vh;
  padding-top: ${({ topPadding }): string => topPadding ?? '0px'};

  ${({ hasAppBarScrollTransition, isScrolled }): SimpleInterpolation | false | undefined =>
    hasAppBarScrollTransition &&
    css`
      header {
        & svg {
          fill: ${isScrolled ? 'revert' : 'white'};
          transition: fill ease-out 0.3s;
        }

        & > div {
          border-color: ${isScrolled ? '#e5e5e5' : 'rgba(229, 229, 229, 0.2)'};
          transition: border-color ease-out 0.3s;

          & > div {
            background: ${isScrolled ? 'white' : 'transparent'};
            transition: background ease-out 0.3s;
          }
        }
      }
    `};
`;
